import { inject } from '@angular/core';
import { AuthStore } from '../stores/auth.store';
import { Router } from '@angular/router';

export const AuthGuard: () => boolean = () => {
  const state = inject(AuthStore);
  const router = inject(Router);

  const guids = location.pathname.substring(1).split('/');
  if (!state.user()) {
    router.navigateByUrl(`uc/login/${ guids.pop() }`);
  }
  return true;
};
